import { render, staticRenderFns } from "./NewsTemplate.vue?vue&type=template&id=1f7eed74&"
import script from "./NewsTemplate.vue?vue&type=script&lang=js&"
export * from "./NewsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./NewsTemplate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports